// --- Invoice Queries ---

const invoiceFields = `
  invoiceId
  invoiceNumber
  orderId
  orderNumber
  companyId
  storeId
  customerId
  subtotalAmount
  discountAmount
  taxAmount
  totalAmount
  paidAmount
  remainingAmount
  status
  issueDate
  createdAt
  payments {
    paymentId
    invoiceId
    invoiceNumber
    amount
    paymentDate
    reference
    paymentMethod
    createdAt
  }
`;

export const listInvoicesQuery = `
  query ListInvoices($input: ListInvoicesInput) {
    listInvoices(input: $input) {
      code
      invoices {
${invoiceFields}
      }
    }
  }
`;

export const listInvoicesByStoreQuery = `
  query ListInvoicesByStore {
    listInvoicesByStore {
      code
      invoices {
${invoiceFields}
      }
    }
  }
`;

export const getInvoiceByOrderQuery = `
  query GetInvoiceByOrder($input: GetInvoiceByOrderInput!) {
    getInvoiceByOrder(input: $input) {
      code
      invoice {
${invoiceFields}
      }
    }
  }
`;

export const getInvoiceByIdQuery = `
  query GetInvoiceById($input: GetInvoiceByIdInput!) {
    getInvoiceById(input: $input) {
      code
      invoice {
${invoiceFields}
      }
    }
  }
`;

// --- Invoice Payment Queries ---

export const listInvoicePaymentsQuery = `
  query ListInvoicePayments($input: ListInvoicePaymentsInput!) {
    listInvoicePayments(input: $input) {
      code
      payments {
        paymentId
        invoiceId
        invoiceNumber
        amount
        paymentDate
        reference
        paymentMethod
        createdAt
      }
    }
  }
`;

export const listInvoicePaymentsByOrderQuery = `
  query ListInvoicePaymentsByOrder($input: GetInvoicePaymentsByOrderInput!) {
    listInvoicePaymentsByOrder(input: $input) {
      code
      payments {
        paymentId
        invoiceId
        invoiceNumber
        amount
        paymentDate
        reference
        paymentMethod
        createdAt
      }
    }
  }
`;

export const listInvoicePaymentsByCompanyQuery = `
  query ListInvoicePaymentsByCompany {
    listInvoicePaymentsByCompany {
      code
      payments {
        paymentId
        invoiceId
        invoiceNumber
        amount
        paymentDate
        reference
        paymentMethod
        createdAt
      }
    }
  }
`;

export const listInvoicePaymentsByStoreQuery = `
  query ListInvoicePaymentsByStore {
    listInvoicePaymentsByStore {
      code
      payments {
        paymentId
        invoiceId
        invoiceNumber
        amount
        paymentDate
        reference
        paymentMethod
        createdAt
      }
    }
  }
`;

export const getInvoicePaymentByIdQuery = `
  query GetInvoicePaymentById($input: GetInvoicePaymentByIdInput!) {
    getInvoicePaymentById(input: $input) {
      code
      payment {
        paymentId
        invoiceId
        invoiceNumber
        amount
        paymentDate
        reference
        paymentMethod
        createdAt
      }
    }
  }
`;

// --- Invoice Mutations ---

export const issueInvoiceMutation = `
  mutation IssueInvoice($input: IssueInvoiceInput!) {
    issueInvoice(input: $input) {
      code
      invoice {
${invoiceFields}
      }
    }
  }
`;

export const updateInvoiceMutation = `
  mutation UpdateInvoice($input: UpdateInvoiceInput!) {
    updateInvoice(input: $input) {
      code
      invoice {
${invoiceFields}
      }
    }
  }
`;

// Returns RecordPaymentResponse → { code, invoice, receipt }
export const recordPaymentMutation = `
  mutation RecordPayment($input: RecordPaymentInput!) {
    recordPayment(input: $input) {
      code
      invoice {
${invoiceFields}
      }
      receipt {
        receiptId
        paymentId
        invoiceId
        invoiceNumber
        orderId
        orderNumber
        amount
        paymentDate
        reference
        paymentMethod
        createdAt
        status
      }
    }
  }
`;

// Returns GetInvoicePaymentResponse → { code, payment }
export const updateInvoicePaymentMutation = `
  mutation UpdateInvoicePayment($input: UpdateInvoicePaymentInput!) {
    updateInvoicePayment(input: $input) {
      code
      payment {
        paymentId
        invoiceId
        invoiceNumber
        amount
        paymentDate
        reference
        paymentMethod
        createdAt
      }
    }
  }
`;

// Returns DeletePaymentResponse → { code }
export const deleteInvoicePaymentMutation = `
  mutation DeleteInvoicePayment($input: DeleteInvoicePaymentInput!) {
    deleteInvoicePayment(input: $input) {
      code
    }
  }
`;
